var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M22 19c0 .55-.45 1-1 1-1.47 0-2.87-.46-4.01-1.26-1.06.79-2.39 1.25-3.86 1.25-.56 0-1-.45-1-1 0-.56.44-1 1-1 .9 0 1.71-.24 2.39-.66-.34-.43-.62-.9-.84-1.41-.22-.5.02-1.09.52-1.31.51-.23 1.1.01 1.32.51.12.27.26.52.42.76a4.8 4.8 0 00.62-1.88H13c-.55 0-1-.45-1-1s.45-1 1-1h2.87v-1c0-.55.44-1 1-1 .55 0 1 .45 1 1v1h3.11c.56 0 1 .45 1 1s-.44 1-1 1h-1.4a6.682 6.682 0 01-1.18 3.28c.76.46 1.66.72 2.6.72.55 0 1 .45 1 1zM6.23 4h-.46C3.69 4 2 5.72 2 7.84V14c0 .55.45 1 1 1s1-.45 1-1v-3h4v3c0 .55.45 1 1 1s1-.45 1-1V7.84C10 5.72 8.31 4 6.23 4zM4 9V7.84C4 6.83 4.79 6 5.77 6h.46C7.21 6 8 6.83 8 7.84V9H4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.ebf49190a0ec91bac504bedc6a33f8f1.svg";
export { ForwardRef as ReactComponent };